import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import CSSModules from 'react-css-modules';

import {
  PASSWORD_STATUS,
  VALIDATION_ICONS,
} from '../../constants/passwordRules';
import Icon from '../Icon';
import styles from './index.styl';

function CheckingListTooltip({
  list,
  title: tooltipTitle = 'password.validation.title',
  children = null,
}) {
  const { formatMessage } = useIntl();

  return (
    <div styleName="root">
      <p styleName="title">{formatMessage({ id: tooltipTitle })}</p>
      <ul>
        {list.map(({ status, title }) => {
          const { name, color } = VALIDATION_ICONS[status];
          const danger = status === PASSWORD_STATUS.DANGER;
          return (
            <li
              styleName={cn('item', {
                'item--danger': danger,
              })}
              key={title}
            >
              <Icon
                name={name}
                size={12}
                style={color}
                key={name}
                className="mr2"
              />
              <span>{formatMessage({ id: title })}</span>
            </li>
          );
        })}
      </ul>
      {children}
    </div>
  );
}

export default CSSModules(CheckingListTooltip, styles, { allowMultiple: true });

CheckingListTooltip.propTypes = {
  list: PropTypes.array,
  title: PropTypes.string,
  children: PropTypes.node,
};



// WEBPACK FOOTER //
// ./src/components/CheckPasswordList/index.jsx